new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    // const videoPlataform = document.getElementById("meuVideo");
    // const btnSom = document.getElementById("toggleSom");
    // if (videoPlataform && btnSom) {
    //     btnSom.addEventListener("click", () => {
    //         if (videoPlataform.muted) {
    //             videoPlataform.muted = false;
    //             btnSom.classList.add("active");
    //         } else {
    //             videoPlataform.muted = true;
    //             btnSom.classList.remove("active");
    //         }
    //     });
    // }
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if (bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if (bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    }

    waitForElementToExist('.home__faq').then(element => {
        const faqItems = document.querySelectorAll('.home__faq--list-item');

        if (faqItems.length > 0) {
    faqItems.forEach(item => {
        const faqText = item.querySelector('.home__faq--text');

        if (faqText) {
            let totalHeight = 0;

            // percorre todos os filhos diretos
            Array.from(faqText.children).forEach(child => {
                totalHeight += child.offsetHeight;
            });

            totalHeight += 20;

            faqText.style.height = totalHeight + 'px';
            faqText.classList.add('active');
        }

        item.addEventListener('click', () => {
            item.classList.toggle('active');
            faqText.classList.toggle('active');
        });
    });
}
    });

    waitForElementToExist('.categories').then(element => {
        $('#categories-home-carrousel').slick({
            arrows: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if (firstCarrousel) {
            $('#product_list').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                            arrows: true,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.banner-full').then(element => {
        $('.banner-full').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
        });
    });

    waitForElementToExist('.band-communique').then(element => {
        $('.band-communique').slick({
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 3500,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

    waitForElementToExist('.instagram-banner').then(element => {
        $('.instagram-banner ul').slick({
            arrows: false,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const secondVitrine = element.querySelector('#product_list2');
        if (secondVitrine) {
            $('#product_list2').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                            arrows: true,
                        }
                    }
                ]
            });

            $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

});